import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

class FieldHeader extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      newName: ""
    }
    this.changeName = this.changeName.bind(this)
    this.toggleForm = this.toggleForm.bind(this)
    this.submitForm = this.submitForm.bind(this)
  }

  changeName(e) {
    this.setState({newName: e.target.value})
  }

  toggleForm() {
    this.props.onClick()
    const name = this.props.fields[this.props.id].name || ""
    this.setState(prevState => ({newName: name}))
  }

  submitForm() {
    this.props.onChangeName(this.props.id, this.state.newName)
    this.props.onClick()
  }

  render() {
    const id = this.props.id
    const {name, number} = this.props.fields[id]
    const numberedName = `Field #${number}`
    const formStyle = {display: this.props.active ? "block" : "none"}
    return (
      <tr>
        <td className="field-title" data-id={id}>
          <div style={formStyle} className="field-title-form text-center">
            <p>Add Custom Name</p>
            <form className="form-inline">
              <div className="form-group">
                <label>
                  <input type="text" name="name" value={this.state.newName} onChange={this.changeName} />
                  <button type="button" className="btn btn-default btn-sm" onClick={this.submitForm}>
                    Ok
                  </button>
                </label>
              </div>
            </form>
          </div>
          <div onClick={this.toggleForm} >
            {name || numberedName}
            {name && <div className="field-title-subname">{numberedName}</div>}
          </div>
        </td>
      </tr>
    )
  }
}

FieldHeader.propTypes = {
  id: PropTypes.number.isRequired,
  fields: PropTypes.object,
  onChangeName: PropTypes.func
}

const mapStateToProps = ({entities: {fields}}) =>({fields})

const mapDispatchToProps = dispatch => ({
  onChangeName: (id, name) => dispatch({type: "CHANGE_FIELD_NAME", payload: {id, name}})
})

export default connect(mapStateToProps, mapDispatchToProps)(FieldHeader)
